import { array, mixed, number, object, string } from 'yup';
import {
  Dependents,
  RegisterFormType,
  Spouse,
} from '../../interface/RegisterForm';

export const RegisterFormSchema = object().shape({
  gender: string<RegisterFormType['gender']>().required('Campo obrigatório'),
  maritalStatus:
    string<RegisterFormType['maritalStatus']>().required('Campo obrigatório'),
  maritalRegime:
    string<RegisterFormType['maritalRegime']>().required('Campo obrigatório'),
  spouse: object<Spouse>()
    .shape({
      name: string().required('Campo obrigatório'),
      gender: string<Spouse['gender']>().required('Campo obrigatório'),
      document: string().required('Campo obrigatório'),
      birthDate: number().required('Campo obrigatório'),
      email: string()
        .email('Por favor, insira um e-mail válido')
        .required('Campo obrigatório'),
      phoneNumber: string().required('Campo obrigatório'),
    })
    .strict(true),
  hasDependents: string<RegisterFormType['hasDependents']>()
    .oneOf(['true', 'false'])
    .required('Campo obrigatório'),
  dependents: array()
    .of(
      object<Dependents>()
        .shape({
          name: string().required('Campo obrigatório'),
          gender: mixed<Dependents['gender']>()
            .defined()
            .required('Campo obrigatório'),
          birthDate: number().defined().required('Campo obrigatório'),
          kinship: mixed<Dependents['kinship']>()
            .defined()
            .required('Campo obrigatório'),
        })
        .strict(true)
    )
    .min(1, 'Adicione pelo menos um dependente'),
});
